export const generateDays = () => {
  return Array.from({ length: 31 }, (_, i) => ({
    value: (i + 1).toString(),
    label: (i + 1).toString(),
  }));
};

export const generateMonths = () => {
  const months = [
    { value: "1", label: "Enero" },
    { value: "2", label: "Febrero" },
    { value: "3", label: "Marzo" },
    { value: "4", label: "Abril" },
    { value: "5", label: "Mayo" },
    { value: "6", label: "Junio" },
    { value: "7", label: "Julio" },
    { value: "8", label: "Agosto" },
    { value: "9", label: "Septiembre" },
    { value: "10", label: "Octubre" },
    { value: "11", label: "Noviembre" },
    { value: "12", label: "Diciembre" },
  ];
  return months;
};

export const generateYears = () => {
  const currentYear = new Date().getFullYear();
  const minYear = currentYear - 100;
  const maxYear = currentYear - 18;
  
  return Array.from({ length: maxYear - minYear + 1 }, (_, i) => ({
    value: (maxYear - i).toString(),
    label: (maxYear - i).toString(),
  }));
};

export const isValidDate = (day, month, year) => {
  if (!day || !month || !year) return false;
  
  const d = parseInt(day, 10);
  const m = parseInt(month, 10);
  const y = parseInt(year, 10);
  
  if (y < 1900 || y > new Date().getFullYear()) return false;
  if (m < 1 || m > 12) return false;
  if (d < 1 || d > 31) return false;
  
  const daysInMonth = getDaysInMonth(m, y);
  if (d > daysInMonth) return false;
  
  const date = new Date(y, m - 1, d);
  return (
    date.getFullYear() === y &&
    date.getMonth() === m - 1 &&
    date.getDate() === d
  );
};

export const getDaysInMonth = (month, year) => {
  return new Date(year, month, 0).getDate();
};

export const validateDateCompleteness = (day, month, year) => {
  return !!(day && month && year);
};

export const validateDateLogic = (day, month, year) => {
  if (!validateDateCompleteness(day, month, year)) return true;
  return isValidDate(day, month, year);
};